module.exports = __webpack_public_path__ + "static/media/Beet farmer - seed to harvest final script_1614783375407.c47363c6.docx";